import React, { useEffect, useState } from 'react';
import Dropdown from "../../../../shared/FormComponents/CustomDropdown/CustomDropdown";
import { characterRegex, creditCardRegex, cvvRegex } from '../../../../../common/constant';
import { Months } from '../../../../../common/Months';
import DIContainer from '../../../../../config/di.container';
import DITYPES from '../../../../../config/di.types';
import OnBoardingLookupService from '../../../../../services/OnboardingService';
import ErrorMessage from '../../../../shared/FormComponents/ErrorMessage/ErrorMessage';
import { Controller, get, useForm } from 'react-hook-form';
import '../../RequestLive/RequestLive.scss';

export interface ICreditCardDetailsProps {
    register: any;
    errors: any;
    onChangeHandler: any;
    control: any;
}

const onboardingLookupService = DIContainer.get<OnBoardingLookupService>(DITYPES.OnboardingLookupService);

const CreditCardDetails: React.FC<ICreditCardDetailsProps> = (props) => {

    const [months, setMonths] = useState(Months);
    const [expiryYears, setExpiryYears] = useState<any[]>();

    const onYearsChangeHandler = async (selectedYear: any) => {
        if (selectedYear == new Date().getFullYear()) {
            var month = new Date().getMonth();
            var monthsArray = Months.slice(month, 12);
            setMonths(monthsArray);
        }
        else {
            setMonths(Months);
        }
    }

    const onMonthsChangeHandler = async (selectedMonth: any) => {
        let expiryYears = await onboardingLookupService.getExpiryYears();
        if (selectedMonth <= new Date().getMonth()) {
            var yearsArray = expiryYears.slice(1, 12);
            setExpiryYears(yearsArray);
        }
        else {
            setExpiryYears(expiryYears);
        }
    }

    let CCDetailsForm: any = {
        ccfirstName: {
            Label: "First name",
            FieldName: "ccFirstName",
            ValidationAndEvent: { required: true, pattern: characterRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        cclastName: {
            Label: "Last name",
            FieldName: "ccLastName",
            ValidationAndEvent: { required: true, pattern: characterRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        creditCard: {
            Label: "Credit card number",
            FieldName: "ccNumber",
            ValidationAndEvent: { required: true, pattern: creditCardRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        ccExpiryMonth: {
            Label: "Expiration month",
            FieldName: "expMonth",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        ccExpiryYear: {
            Label: "Expiration year",
            FieldName: "expYear",
            ValidationAndEvent: { required: true, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        },
        cvv: {
            Label: "CVV/CVC",
            FieldName: "cvv",
            ValidationAndEvent: { required: true, pattern: cvvRegex, onChange: (e) => { props?.onChangeHandler(e) }, onBlur: (e) => { props?.onChangeHandler(e) } }
        }
    }
    return (
        <div className="about-int-secton">
            <span className="about-sec-header">Credit Card Information</span>
            <div className="request-live-text cc-details-note">Note: Your credit card will not be charged now. It will be securely saved for a faster payment experience in the future.</div>
            <div className="d-flex">
                {
                    <div className="padding-top-32 w-50">
                        <div className="wd-100">
                            <label className="activate-launch-label">{CCDetailsForm.ccfirstName.Label}*</label>
                            <input {...props?.register(CCDetailsForm.ccfirstName.FieldName, CCDetailsForm.ccfirstName.ValidationAndEvent)}
                                maxLength={15} className="first-name-input" type="text" id="ob-cc-first-name" autoComplete="disabled"
                            >
                            </input>
                            <ErrorMessage errors={props.errors} {...CCDetailsForm.ccfirstName} message={"must contain only charaters."}></ErrorMessage>
                        </div>
                    </div>
                }
                {

                    <div className="padding-top-32 w-50">
                        <div className="last-name-container">
                            <label className="activate-launch-label">{CCDetailsForm.cclastName.Label}*</label>
                            <input {...props?.register(CCDetailsForm.cclastName.FieldName, CCDetailsForm.cclastName.ValidationAndEvent)}
                                maxLength={30} className="last-name-input" type="text" id="ob-cc-last-name" autoComplete="disabled"
                            />
                            <ErrorMessage errors={props.errors} {...CCDetailsForm.cclastName} message={"must contain only charaters."}></ErrorMessage>
                        </div>
                    </div>
                }
            </div>
            <div className="d-flex">
                {CCDetailsForm.creditCard &&
                    <div className="padding-top-32 wd-100">
                        <label className="activate-launch-label">{CCDetailsForm.creditCard.Label}*</label>
                        <input {...props?.register(CCDetailsForm.creditCard.FieldName, CCDetailsForm.creditCard.ValidationAndEvent)}
                            autoComplete="off" className="business-name-input" type="text" id="ob-cc-number"
                        >
                        </input>
                        <ErrorMessage errors={props.errors} {...CCDetailsForm.creditCard} message={"is not valid."}></ErrorMessage>
                    </div>
                }
            </div>
            <div className="d-flex justify-content-between">
                {
                    <div className="padding-top-32 wd-50">
                        <div className="inte-dr-div inte-dr-div-left">
                            {/* @ts-ignore */}
                            <Controller
                                control={props.control}
                                name="expMonth"
                                rules={{ required: true }}
                                render={(
                                    { field: { onChange, value, ref, ...field },
                                        fieldState: { invalid }
                                    }) => (
                                    <Dropdown
                                        {...field}
                                        data={months}
                                        id="ccExpiryMonth"
                                        value={value}
                                        changeFunc={(value) => onChange(value, onMonthsChangeHandler(value))}
                                        label={`${CCDetailsForm.ccExpiryMonth.Label}*`}
                                        controlId="expMonth"
                                        isCheckMark
                                        error={invalid}
                                        placeholder="Select a month"
                                        classNameLabel="activate-launch-label"
                                    />
                                )}
                            />
                        </div>
                    </div>
                }
                {<div className="padding-top-32 int-typ-drop wd-50">
                    <div className="inte-dr-div">
                        {/* @ts-ignore */}
                        <Controller
                            control={props.control}
                            name="expYear"
                            rules={{ required: true }}
                            render={({ field: { onChange, onBlur, value, ref },
                                fieldState: { invalid, isTouched, isDirty, error }
                            }) => (
                                <Dropdown className="lang-drop"
                                    data={expiryYears}
                                    id="ccExpiryYear"
                                    value={value}
                                    changeFunc={(value) => onChange(value, onYearsChangeHandler(value))}
                                    label={`${CCDetailsForm.ccExpiryYear.Label}*`}
                                    controlId="expYear"
                                    isCheckMark
                                    error={invalid}
                                    placeholder="Select year"
                                    classNameLabel="activate-launch-label"
                                    valueField="Value"
                                    labelField="Label"
                                />
                            )}
                        />
                    </div>
                </div>
                }
            </div>
            <div className="d-flex">
                {
                    <div className="padding-top-32 w-50">
                        <div className="wd-100">
                            <label className="activate-launch-label">{CCDetailsForm.cvv.Label}*</label>
                            <input {...props?.register(CCDetailsForm.cvv.FieldName, CCDetailsForm.cvv.ValidationAndEvent)}
                                maxLength={4} className="first-name-input" type="text" id="request-live-cvv" autoComplete="off"
                            >
                            </input>
                            <ErrorMessage errors={props.errors} {...CCDetailsForm.cvv} message={"is not valid."}></ErrorMessage>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default CreditCardDetails;